import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestChartDescriptions } from '@/src/compliance/redux/complianceReducer';
import Heading from '@/src/shared/components/Heading';
import Loading from '@/src/shared/components/LoadingResults';
import { form as formStyle } from '@/styles';

import ChartDescription from './ChartDescriptionTile';

const index = () => {
  const dispatch = useDispatch();

  const { chartDescriptions = [], isLoadingChartDescriptions } = useSelector(
    state => state.compliance.chartDescriptions
  );

  useEffect(() => {
    dispatch(requestChartDescriptions());
  }, [dispatch]);

  return (
    <div>
      {isLoadingChartDescriptions ? (
        <Loading />
      ) : (
        <>
          <div css={formStyle.gridColHeader}>
            <Heading type={4} weight="bolder" theme="gray">
              Title
            </Heading>
            <Heading type={4} weight="bolder" theme="gray">
              Description
            </Heading>
          </div>

          {chartDescriptions.map(cd => (
            <ChartDescription chart={cd} key={cd.ChartId} />
          ))}
        </>
      )}
    </div>
  );
};

export default index;